<select class="custom-select" [(ngModel)]="this.value" (ngModelChange)="changed( )">
    <option value="0">-- Select Stage --</option>
    <option *ngFor="let item of tree" [value]="item.value">{{item.label}}</option>
</select>
